export default __webpack_public_path__ + "3e8d18f229c7bcbdc4d173e11e267267.svg";